<template>
  <div class="energyManageUser">
    <el-card class="top">
      <span>{{ uname }}</span>
      <div class="btnGroup">
        <div
          :class="[isHeTong ? 'btn active' : 'btn']"
          @click="changeBtn(true)">
          合同管理
        </div>
        <div
          :class="[!isHeTong ? 'btn active' : 'btn']"
          @click="changeBtn(false)">
          业务申报
        </div>
      </div>
    </el-card>
    <el-card class="card">
      <FirstHeading :find="false" style="margin-bottom: 20px">{{
        isHeTong ? "历史合同" : "业务申报"
      }}</FirstHeading>
      <!-- <el-form :inline="true" ref="searchRef" :model="searchForm" class="demo-form-inline">
                <el-form-item label="用户编号">
                    <el-input v-model="searchForm.userNum" placeholder="请输入用户编号"></el-input>
                </el-form-item>
                <el-form-item label="合同编号">
                    <el-input v-model="searchForm.fileNum" placeholder="请输入合同编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" class="searchBtn">查询</el-button>
                </el-form-item>
            </el-form> -->
      <div v-if="isHeTong" class="hetong">
        <el-table
          :data="tableData4"
          border
          height="700"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '7px 0' }"
          :header-cell-style="{
            background: '#e2eeeb',
            fontSize: '16px',
            color: '#000',
            fontWeight: 600,
            padding: '7px 0',
          }">
          <!-- <el-table-column prop="userNum" label="终端用户编号" align="center"></el-table-column> -->
          <el-table-column prop="contractType" label="合同类型" align="center">
            <template slot-scope="scope">
              {{
                scope.row.contractType === 0
                  ? "用电合同"
                  : scope.row.contractType === 1
                  ? "扩容合同"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="contractNum"
            label="合同编号"
            align="center"></el-table-column>
          <el-table-column
            prop="signTime"
            label="签订日期"
            align="center"></el-table-column>
          <el-table-column
            prop="takeTime"
            label="生效日期"
            align="center"></el-table-column>
          <el-table-column
            prop="endTime"
            label="终止日期"
            align="center"></el-table-column>
          <el-table-column
            prop="txIdList"
            label="区块链认证"
            align="center"
            width="600px">
            <template slot-scope="scope">
              <el-tag
                type="success"
                style="color: #068d6c; margin-bottom: 5px"
                >{{ scope.row.qklHash }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="附件" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="changeViewUserNum(scope.row)"
                style="color: #068d6c">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 合同查看的对话框 -->
        <el-dialog
          class="viewDialog"
          title="合同预览"
          :visible.sync="viewDialog"
          width="50%"
          @open="handelFildContract"
          @close="closeDialog">
          <div class="dialogBody" v-if="isPDF">
            <div style="font-size: 18px; margin-bottom: 20px">
              区块链编号：
              <span style="font-size: 14px">{{ txID }}</span>
            </div>
            <iframe style="width: 100%; height: 800px" :src="pdfUrl"></iframe>
          </div>
          <div v-else class="dialogBody">
            <div class="txIdClass">
              <span>区块链编号：</span>
              <span>{{ txID }}</span>
            </div>
            <el-carousel indicator-position="outside" :interval="0">
              <el-carousel-item v-for="item in imageList" :key="item">
                <el-image
                  id="img"
                  :src="item"
                  :preview-src-list="srcList"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-dialog>
      </div>
      <div v-else class="shengbao">
        <el-form
          style="width: 800px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm">
          <el-form-item label="用户编号" prop="realNum">
            <el-input
              v-model="ruleForm.realNum"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="用电地址" prop="userAddr">
            <el-input
              v-model="ruleForm.userAddr"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="identity">
            <el-input
              v-model="ruleForm.identity"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="是否装表" prop="bus">
            <!-- <el-input v-model="ruleForm.bus" placeholder="请输入"></el-input> -->
            <el-select v-model="ruleForm.bus" placeholder="请选择">
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否需要施工" prop="construction">
            <el-select v-model="ruleForm.construction" placeholder="请选择">
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="ruleForm.remark" placeholder="请输入"></el-input>
          </el-form-item>
   
        </el-form>
        <div class="btn">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确认申报</el-button
          >
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import FirstHeading from "@/components/firstHeading.vue";
import {
  getHistoryFile,
  checkContract,
  businessApi,
} from "@/api/energyManagement.js";
// import { getFildContract } from "@/api/powerInformation.js";
export default {
  name: "energyManageUser",
  components: { FirstHeading },
  data() {
    return {
      // searchForm: {},  //搜索表单
      tableData4: [],
      viewDialog: false,
      isPDF: false, //文件类型（图片还是pdf），用于判断dialog中的内容显示
      pdfUrl: "",
      txID: "",
      srcList: [],
      imageList: [],
      viewId: "",
      uname: sessionStorage.getItem("uname"),
      isHeTong: true,
      ruleForm: {},
      rules: {
        realNum: [
          { required: true, message: "请输入用户编号", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          {
            required: true,
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "change",
          },
        ],
        userAddr: [
          { required: true, message: "请输入用电地址", trigger: "blur" },
        ],
        identity: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ],
        bus: [
          {
            required: true,
            message: "请选择是否装表",
            trigger: "change",
          },
        ],
        construction: [
          { required: true, message: "请选择是否需要施工", trigger: "change" },
        ],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getHistoryData();
  },
  methods: {
    // 历史合同查询按钮
    handleSearch() {
      if (JSON.stringify(this.searchForm) === "{}") return;
      this.getHistoryData();
    },
    // 获取历史合同数据
    async getHistoryData() {
      // const query = JSON.stringify(this.searchForm) === '{}' ? '':this.searchForm
      const res = await getHistoryFile(this.searchForm);
      if (res.code === 200) {
        this.tableData4 = res.data;
      } else return this.$message.error(res.msg);
    },
    // 点击查看按钮
    changeViewUserNum(row) {
      this.txID = row.qklHash;
      this.viewuserNum = row.id;
      this.viewDialog = true;
    },
    // 打开查看合同对话框的回调函数
    async handelFildContract() {
      const res = await checkContract(this.viewuserNum);
      if (res.code === 200) {
        if (res.data.length === 0) {
          this.$message.warning("合同未上传！");
        } else {
          console.log(res.data);
          this.isPDF = res.data.fileType === 0;
          // 合同为pdf格式
          if (this.isPDF) {
            // window.open(res.data[0].url)
            this.pdfUrl = `${res.data.urlList[0]}?${res.data.hash}`;
            // this.txID = res.data[0].txId;
          } else {
            // 合同为image图片
            this.imageList = res.data.urlList;
            this.srcList = res.data.urlList;
            // this.imageList = res.data;
            // res.data.forEach((item, i) => {
            //   this.srcList.push(item.url);
            // });
          }
        }
      }
    },
    // 关闭查看合同对话框的回调函数
    closeDialog() {
      this.srcList = [];
      this.imageList = [];
    },
    // 点击头部右侧的按钮组
    changeBtn(val) {
      this.isHeTong = val;
    },
    // 业务申报按钮点击事件
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          businessApi(this.ruleForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              setTimeout(() => {
                this.changeBtn(true);
                this.ruleForm = {};
              }, 1000);
            } else {
              this.$message.error(res.msg);
            }
          });

          // alert(, "申报成功");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.energyManageUser {
  width: 100%;
  max-width: 1872px;
  margin: 0 auto;

  .top {
    height: 64px;
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0;

    ::v-deep .el-card__body {
      width: 100%;
      height: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btnGroup {
        display: flex;

        .btn {
          width: 100px;
          height: 38px;
          line-height: 38px;
          background-color: #eff2f2;
          color: #8b9996;
          // padding: 5px;
          box-sizing: border-box;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
        }

        > div:nth-child(1) {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          // margin-right: 1px;
        }

        > div:nth-child(2) {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }

        .active {
          background-color: #068d6c;
          color: #fff;
        }
      }
    }

    // span {
    //   color: #068667 !important;
    // }
  }

  .card {
    width: 100%;

    .uploadBtn {
      padding: 0;
      color: #068d6c;
      font-weight: 700;
    }

    .demo-form-inline {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .searchBtn {
        background-color: #068d6c;
        color: #fff;
      }
    }

    .viewDialog {
      :deep(.dialogBody) {
        width: 100% !important;

        .el-carousel__container {
          height: 600px;

          .el-carousel__item {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .el-image {
            width: 100%;
            height: 90%;

            > img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .txIdClass {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            > span:nth-child(1) {
              // font-size: 18px;
            }
          }
        }

        .txIdClass {
          margin-bottom: 10px;

          > span:nth-child(1) {
            font-size: 18px;
          }

          > span:nth-child(2) {
            font-size: 18px;
            color: #068667;
          }
        }
      }
    }
    .shengbao {
      .btn {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
